import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  Input,
  OnInit,
  SkipSelf,
} from '@angular/core';
import {
  AbstractControl,
  ControlContainer,
  FormGroupDirective,
  UntypedFormGroup,
} from '@angular/forms';
import { FormControlOption } from '@app/forms/subscription/definition/interface/formControlOption.interface';
import {
  beneficiaryTypeOptions,
  beneficiaryTypeWithoutNotarialeOptions,
} from '@app/forms/subscription/services/ref';
import { SubscriptionFacadeService } from '@app/forms/subscription/services/subscription-facade.service';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { Observable, delay, startWith } from 'rxjs';

@UntilDestroy()
@Component({
    selector: 'beneficiary-type',
    templateUrl: './beneficiary-type.component.html',
    styleUrls: ['./beneficiary-type.component.scss'],
    viewProviders: [
        {
            provide: ControlContainer,
            useFactory: (container: ControlContainer) => container,
            deps: [[new SkipSelf(), ControlContainer]],
        },
    ],
    standalone: false
})
export class BeneficiaryTypeComponent implements OnInit, AfterViewInit {
  @Input() derrors = false;
  isCorumProduct = false;
  options: FormControlOption[] = beneficiaryTypeOptions;
  constructor(
    private controlContainer: FormGroupDirective,
    private cd: ChangeDetectorRef,
    public subscriptionFacade: SubscriptionFacadeService,
  ) {}
  get form() {
    return this.controlContainer.form.get('parameters') as UntypedFormGroup;
  }
  ngAfterViewInit(): void {}

  valuesOf(control: AbstractControl): Observable<any> {
    return control.valueChanges.pipe(startWith(control.value));
  }
  ngOnInit() {
    const pledge = this.subscriptionFacade.getPledge();
    const product = pledge?.products?.[0];

    if (product?.parameters?.partnerFlux === 'CORUM') {
      this.options = beneficiaryTypeWithoutNotarialeOptions;
      this.isCorumProduct = true;
    }

    this.form
      .get('avClauseBeneficiaire')
      .valueChanges.pipe(
        delay(0),

        untilDestroyed(this),
      )
      .subscribe(data => {
        if (data == 'STANDARD') {
          this.setValueToNull([
            'avClauseBeneficiaireLibre',
            'avClauseBeneficiaireNomNotaire',
            'avClauseBeneficiairePrenomNotaire',
          ]);
          this.setFormGroupToNull('avClauseBeneficiaireAddresseNotaire');
        } else if (data == 'LIBRE') {
          this.setValueToNull([
            'avClauseBeneficiaireStandard',
            'avClauseBeneficiaireNomNotaire',
            'avClauseBeneficiairePrenomNotaire',
          ]);
          this.setFormGroupToNull('avClauseBeneficiaireAddresseNotaire');
        } else if (data == 'NOTARIALE') {
          this.setValueToNull([
            'avClauseBeneficiaireStandard',
            'avClauseBeneficiaireLibre',
          ]);
        }
      });
    this.cd.detectChanges();
  }

  setValueToNull(controls: string[]) {
    controls.forEach(control => {
      this.form.get(control)?.setValue(null);
    });
  }

  setFormGroupToNull(control: string) {
    Object.keys(this.form.get(control).value).forEach(key => {
      this.form.get(control).get(key).setValue(null);
    });
  }
}
